import { Component, Input, SimpleChanges } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FormControl, FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Subject, debounceTime, switchMap } from 'rxjs';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-deploys',
  standalone: true,
  imports: [
    MatTableModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    MatGridListModule,
  ],
  templateUrl: './deploys.component.html',
  styleUrl: './deploys.component.css',
})
export class DeploysComponent {
  @Input() tabSelected: boolean = false;
  displayedColumnsForm = new FormControl('');

  displayedColumns: string[] = [
    'group',
    'model',
    'version',
    'version-update',
    'actions',
  ];
  filteredColumns: string[] = this.displayedColumns.filter(
    (col) => col !== 'actions' && col !== 'version-update'
  );
  dataSource = new MatTableDataSource();
  selectedColumn: string = 'mac'; // Default column to filter by
  filterValue: string = '';
  currentPage = 1;
  firmwares: any;

  private filterSubject = new Subject<[string, number]>();

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    this.apiService.getFirmwares(1, {}).subscribe((data) => {
      this.firmwares = data;
    });
    // Listen for changes to filterValue, apply debounce on the API call
    this.filterSubject
      .pipe(
        debounceTime(300), // Debounce time in ms
        switchMap(([filterValue, currentPage]) => {
          let filters: any = {};
          if (filterValue) {
            filters[this.selectedColumn] = filterValue;
          }
          return this.apiService.getDeploys(currentPage, filters); // API call with filters
        })
      )
      .subscribe((data) => {
        this.dataSource = new MatTableDataSource(data);
      });

    this.filterSubject.next([this.filterValue, this.currentPage]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabSelected'] && changes['tabSelected'].currentValue) {
      this.apiService.getFirmwares(1, {}).subscribe((data) => {
        this.firmwares = data;
      });
      this.filterSubject.next([this.filterValue, this.currentPage]);
    }
  }
  // Trigger the filter change and emit the new value to filterSubject
  onFilterChange() {
    this.currentPage = 1; // Reset to the first page when filter changes
    this.filterSubject.next([this.filterValue, this.currentPage]);
  }

  onDeleteClick(element: { model: string; version: string; group: string }) {
    const isConfirmed = window.confirm(
      `Vuoi eliminare il modello ${element.model} firmware ${element.version}?`
    );

    if (!isConfirmed) {
      return;
    }

    this.apiService.deleteDeploy(element.group, element.model).subscribe(() => {
      this.filterSubject.next([this.filterValue, this.currentPage]);
    });
  }

  onDeployVersionChange(group: string, model: string, version: string) {
    const isConfirmed = window.confirm(
      `Vuoi cambiare il firmware del modello ${model} che appartiene al gruppo ${group} con la versione ${version}?`
    );

    if (!isConfirmed) {
      return;
    }

    this.apiService.updateDeploy(group, model, version).subscribe(() => {
      this.filterSubject.next([this.filterValue, this.currentPage]);
    });
  }

  getFirmwaresByModel(model: string) {
    return this.firmwares.filter((firmware: any) => firmware.model === model);
  }

  onNext() {
    if (this.dataSource.data.length === 0) {
      return;
    }
    this.currentPage++;
    this.filterSubject.next([this.filterValue, this.currentPage]);
  }

  onPrev() {
    if (this.currentPage <= 1) {
      return;
    }

    this.currentPage--;
    this.filterSubject.next([this.filterValue, this.currentPage]);
  }
}
